import { Component, Input } from '@angular/core';
import { IReporteActuacion } from 'src/app/models/empresa-en-un-dia/empresa-en-un-dia-actuacion.model';

@Component({
  selector: 'app-actuaciones-viewer',
  templateUrl: './actuaciones-viewer.component.html',
  styleUrls: ['./actuaciones-viewer.component.scss']
})
export class ActuacionesViewerComponent {
  @Input() rut = '';
  @Input() data: IReporteActuacion | null = null;
  @Input() showHeader = true;

  public today = '';
  public elements: {titulo: string, value: any, type: string}[] = [];

  ngOnInit(): void {
    this.setToday();
    this.setElements();
  }

  setToday() {
    this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) :
      new Date().getMonth() + 1)}${new Date().getDate()}`;
  }

  setElements(): void {
    this.elements = [];
    if(!this.data) return;
    // N° Atención
    this.elements.push({
      titulo: "N° Atención",
      value: this.data?.rso_numeroatencion,
      type: "text"
    });
    // RUT
    this.elements.push({
      titulo: "RUT",
      value: this.data?.run,
      type: "rut"
    });
    // Tipo
    this.elements.push({
      titulo: "Tipo",
      value: this.data?.tac_glosa,
      type: "text"
    });
    // Fecha
    this.elements.push({
      titulo: "Fecha",
      value: this.data?.rso_fechacreacion,
      type: "fecha"
    });
    // Comuna
    /*this.elements.push({
      titulo: "Comuna",
      value: this.data?.tsoc_codigo, // validar**
      type: "text"
    });*/
    // Representante legal
    this.elements.push({
      titulo: "Representante legal",
      value: this.data?.rso_razonsocial,
      type: "text"
    });
    //Tipo de Sociedad
    this.elements.push({
      titulo: "Tipo de Sociedad",
      value: this.data?.tsoc_codigo,
      type: "text"
    });
  }

}
